import { colId, DataTableColumn } from './DataTableColumn';

export function findCol<T = any>(cols: (string | DataTableColumn<T>)[], name:string):DataTableColumn<T> {
  //@ts-ignore
  return cols.find(c => colId(c) === name);
}
